import Card from '@perpay-web/components/base/Card/Card';
import Stack from '@perpay-web/components/design-system/Stack/Stack';
import { getClassName } from '@perpay-web/utils/domUtils';
import { noop } from '@perpay-web/utils/noop';

import styles from './CustomerServiceInfo.scss';

const phoneHref = 'tel:+18669861669';

const CustomerServiceInfo = ({ className = '', onClickPhoneNumber = noop }) => (
    <Card className={getClassName(styles.card, className)}>
        <div className={styles['contact-title']}>
            Have questions? Call us at
        </div>
        <a href={phoneHref} onClick={onClickPhoneNumber}>
            <div className={styles.number}>+1 (866) 986-1669</div>
        </a>
        <Stack className={styles.timings}>
            <p>Monday - Friday: 9am - 9pm (ET)</p>
            <p>Saturday: 10am - 3pm (ET)</p>
        </Stack>
    </Card>
);

export default CustomerServiceInfo;
